
	import Recorder from 'js-audio-recorder'
	const lamejs = require('lamejs')
	import appconst from '@/lib/appconst'
	/**
	 * @param isShow 是否显示音频录入组件
	 * @param closeAudio 关闭音频录入组件或录音完毕的事件
	 */
	export default {
		name: 'AudioEnter',
		props: {
			isShow: {
				type: Boolean,
				default: false
			},
			title: {
				type: String
			},
			sendTitle: {
				type: String
			},
			pctitle: {
				type: String
			},
			pcsendTitle: {
				type: String
			},
			ispc: {
				type: Boolean
			},
			// hasPermission:{
			// 	type:Boolean
			// },
			disabled: {
				type: Boolean,
				default: false
			},
			prompt: {
				type: String,
				default: false
			},
		},

		data() {
			return {
				beginRecoding: false, // 开始录音
				showBoxing: false,//
				blackBoxSpeak: false, // 是否上滑取消
				startY: 0, // 手指滑动开始Y轴坐标
				pageWidth: 360, // 页面宽度
				timeOutEvent: 0, // 定时器
				waveCanvas: null,
				ctx: null,
				recorder: null, // 音频录入的实例
				drawRecordId: null, // 音频绘画波动图时的音频id
				nowDuration: null, // 当前时长
				duration: 0,
				limitDuration: 60, // 限制时长，单位-秒
				drawColuList: [],// 录音时的柱状波动图，数据集合

				haveMoveUp: false,//有上滑

				hasPermission: false, //是否有麦克风权限

				//middle、cancel、trans
				showVoice: 'middle',
				//在转文字上松开
				touchEndTrans: false,

				content: '',

				loadTransComp: false, //翻译完成
				showLoading:false,
				
				
				stopRecord:true,	
				jiexi:false,
				

				//disabled:false
			}
		},
		computed: {
			isMiddle() {
				return this.showVoice == "middle"
			},
			isCancel() {
				return this.showVoice == "cancel"
			},
			isTrans() {
				return this.showVoice == "trans"
			}
		},
		watch: {
			'isShow': {
				handler(nv, ov) {
					if (nv) {
						this.getPermission()
					}
				},
				deep: true
			},
			'disabled': {
				handler(nv, ov) {

				},
				deep: true
			},
			'prompt': {
				handler(nv, ov) {					
					this.initial(nv)					
				},
				deep: true
			}
		},
		mounted() {
			// 创建录音实例
			this.recorder = new Recorder({
				sampleBits: 16,                 // 采样位数，支持 8 或 16，默认是16
				sampleRate: 16000,              // 采样率，支持 11025、16000、22050、24000、44100、48000，根据浏览器默认值
				numChannels: 1,                 // 声道，支持 1 或 2， 默认是1
				// compiling: false,(0.x版本中生效,1.x增加中)  // 是否边录边转换，默认是false
			})
			// 监听录音变化
			const vm = this;
			this.recorder.onprogress = function (params) {				
				vm.duration = params.duration.toFixed(2);
				console.log(vm.duration)
				if (Math.floor(params.duration) >= vm.limitDuration) {
					vm.touchend();
				}
				let d = Math.floor(params.duration);

				var dd = Number(d) < 10 ? '0' + d : d;
				dd = '0:' + d;
				vm.$set(vm, 'nowDuration', dd)

				// console.log('--------------START---------------')
				// console.log('录音时长(秒)', params.duration);
				// console.log('录音大小(字节)', params.fileSize);
				// console.log('录音音量百分比(%)', params.vol);
				// console.log('当前录音的总数据([DataView, DataView...])', params.data);
				// console.log('--------------END---------------')
			}
			this.pageWidth = window.innerWidth;
			this.getPermission()
			//this.startCanvas();
		},
		methods: {
			initial(nv){
				this.content = nv;
				this.jiexi=false;
				this.loadTransComp = true
				this.showLoading=false;
				this.showBoxing=true;
			},
			L(value : string, source ?: string, ...argus : string[]) : string {
				if (source) {
					return window.abp.localization.localize(value, source, argus);
				} else {
					return window.abp.localization.localize(value, appconst.localization.defaultLocalizationSourceName, argus);
				}

			},
			// 获取麦克风权限
			getPermission() {
				var _this = this;
				Recorder.getPermission().then(() => {
					_this.hasPermission = true;
					console.log('录音给权限了');
				}, (error) => {
					_this.hasPermission = false;
					console.log(`${error.name} : ${error.message}`);
				});
			},
			// 波浪图canvas 配置
			startCanvas() {
				//录音波浪
				this.waveCanvas = document.getElementById('canvas');
				this.waveCanvas.width = 145;
				this.waveCanvas.height = 44;
				this.ctx = this.waveCanvas.getContext("2d");
			},
			cancelAudio() {
				console.log("cancel")
				this.showBoxing = false;
				this.loadTransComp=false;
				this.content = "";
				//this.$emit('prompt',"")
			},
			voiceChange(){
				this.$emit('voiceChange')
			},
			sendAudio() {
				this.$emit('sendAudio', this.content)
				this.showBoxing = false;
			},
			promptChange(e) {
				//console.log(e)
				this.$emit('prompt', e)
			},
			audiostart() {
				console.log("audiostart")
				
				var websocket = new WebSocket("wss://tingwu-realtime-cn-beijing.aliyuncs.com/api/ws/v1?mc=p-7f1eXTYH7o8WZqNEq1mbecI1rtDZRllROA7d7Orp3MR9Nlv1epLAg0buQxhuL--2lAyRnmDv3zEnLPzAT2keBZpiTYh-AXGDa4yiw6F1U=")
				
				websocket.onopen = function () {
					console.log("WebSocket连接成功");
					//websocket.send("");
				};
				
				websocket.onmessage = function (event) {
					console.log("接收到服务端消息：" + event.data)
					var result= JSON.parse(event.data);
					debugger
					if(result.header.name=="TaskFailed"){
						console.log(result.header.status_text)
					}
				};
				
				websocket.onerror = function () {
					console.log("WebSocket连接发生错误");
				};
				
				websocket.onclose = function () {
				console.log("WebSocket连接关闭");
				};
				
				// if (!this.beginRecoding) {
				// 	this.blackBoxSpeak = true

				// 	this.timeOutEvent = 0
				// 	// 长按1000毫秒后执行
				// 	this.timeOutEvent = setTimeout(() => {
				// 		this.startRecorder();
				// 		this.beginRecoding = true
				// 	}, 50)
				// 	return false
				// }
				// else {
				// 	this.touchend()
				// }

			},
			// 手指开始触发
			touchstart(e) {
				console.log("touchstart");
				var _this = this;
				// Recorder.getPermission().then(() => {					


				// }, (error) => {
				// 	_this.hasPermission=false;					
				// 	console.log(`${error.name} : ${error.message}`);
				// });

				if (!this.hasPermission) {
					_this.$Message.warning("请先开启麦克风权限")
					return false
				}
				if (this.beginRecoding) {
					return false
				}
				this.blackBoxSpeak = true
				this.haveMoveUp = false;
				this.showVoice = 'middle';
				this.touchEndTrans = false;
				this.loadTransComp = false;
				this.showLoading=true;
				this.stopRecord=false;
				this.showBoxing = false;	
				this.content='';
				this.jiexi=false;
				try {
					this.startY = e.touches[0].clientY
					
				} catch (e) {
					//TODO handle the exception
				}
				if (!this.disabled) {
					//this.timeOutEvent = 0
					var that=this;
					this.recorder= new Recorder({
				sampleBits: 16,                 // 采样位数，支持 8 或 16，默认是16
				sampleRate: 16000,              // 采样率，支持 11025、16000、22050、24000、44100、48000，根据浏览器默认值
				numChannels: 1,                 // 声道，支持 1 或 2， 默认是1
				// compiling: false,(0.x版本中生效,1.x增加中)  // 是否边录边转换，默认是false
			})
			
			this.recorder.onprogress = function (params) {
				that.duration = params.duration.toFixed(2);
				//console.log(that.duration)
				if (Math.floor(params.duration) >= that.limitDuration) {
					that.touchend();
				}
				let d = Math.floor(params.duration);
			
				d = Number(d) < 10 ? '0' + d : d;
				d = '0:' + d;
				that.$set(that, 'nowDuration', d)
			
				
			}
					this.recorder.start().then(() => {
						this.beginRecoding = true;
						console.log("stopRecord:"+ this.stopRecord)
						if(this.stopRecord){
							console.log(111)
							that.beginRecoding = false
							that.duration = 0;
							that.nowDuration = null;
							that.drawColuList = [];
							that.blackBoxSpeak = true
							
							that.showBoxing = false;	
							setTimeout(function(){
								console.log(222)
								that.recorder.stop();
								that.recorder.destroy()
							},50)
							
								
						}
						
						//this.drawRecordWave();//开始绘制
						//this.drawRecordColu(); // 开始绘制
					}, (error) => {
						console.log(`${error.name} : ${error.message}`);
					});

				
					return false
				}


			},
			// 手指离开屏幕触发
			touchend() {
				console.log("touchend:" + this.beginRecoding);
				var that=this;
				// if(!this.beginRecoding){
				// 	setTimeout(function(){
				// 		that.recorder.stop();
				// 		that.beginRecoding = false
				// 		that.duration = 0;
				// 		that.nowDuration = null;
				// 		that.drawColuList = [];
				// 		that.blackBoxSpeak = true
				// 		that.haveMoveUp = false;
						
				// 	},200)
				// 	return
				// }
				this.stopRecord=true;
				this.recorder.stop();
				this.beginRecoding = false
				
				if (this.duration > 0.2) {
					this.showBoxing = true;		
					this.jiexi=true;
					//this.$emit('closeAudio', this.recorder.getWAVBlob(), this.touchEndTrans)
					this.$emit('closeAudio', this.recorder.getWAVBlob(), true)
					this.recorder.destroy()
				}
				this.duration = 0;
				this.nowDuration = null;
				this.drawColuList = [];
				this.blackBoxSpeak = true
				this.haveMoveUp = false;
			
			},
			// 滑动触发
			touchmove(e) {

				try {
					const endY = e.touches[0].clientY
					const endX = e.touches[0].clientX
					//console.log("startY:" + this.startY + ",endY:" + endY+",endX:"+endX+",pageWidth:"+this.pageWidth)
					if (endY < this.startY - 50) {
						this.haveMoveUp = true;
						if (endX * 2 < this.pageWidth) {
							this.showVoice = "cancel"
							this.blackBoxSpeak = false;
						}
						else {
							this.showVoice = "trans"
							this.touchEndTrans = true;
							this.blackBoxSpeak = true;
						}

					}
					else {
						this.haveMoveUp = false;
					}
				} catch (e) {
					//TODO handle the exception
				}



				//this.blackBoxSpeak = this.startY < endY
			},
			//长按超过x毫秒-- 开始录音
			startRecorder() {
				this.recorder.start().then(() => {
					this.beginRecoding = true;
					//this.drawRecordWave();//开始绘制
					//this.drawRecordColu(); // 开始绘制
				}, (error) => {
					console.log(`${error.name} : ${error.message}`);
				});
			},
			// 继续录音
			resumeRecorder() {
				this.recorder.resume()
			},
			// 暂停录音
			pauseRecorder() {
				this.recorder.pause();
				this.drawRecordId && cancelAnimationFrame(this.drawRecordId);
				this.drawRecordId = null;
			},
			// 结束录音
			stopRecorder() {
				this.recorder.stop()
				this.drawRecordId && cancelAnimationFrame(this.drawRecordId);
				this.drawRecordId = null;
			},
			// 录音播放
			playRecorder() {
				this.recorder.play();
				//this.drawPlay();//绘制波浪图
			},
			// 暂停录音播放
			pausePlayRecorder() {
				this.recorder.pausePlay()
			},
			// 恢复录音播放
			resumePlayRecorder() {
				this.recorder.resumePlay();
				//this.drawPlay();//绘制波浪图
			},
			// 停止录音播放
			stopPlayRecorder() {
				this.recorder.stopPlay();
			},
			// 销毁录音
			destroyRecorder() {
				const vm = this;
				if (vm.recorder) {
					vm.recorder.destroy().then(function () {
						vm.recorder = null;
						vm.drawRecordId && cancelAnimationFrame(vm.drawRecordId);
						vm.drawRecordId = null;
					});
				}
			},
			// 获取录音文件
			getRecorder() {
				let map = new Map();
				map.set('duration', this.recorder.duration);//录音总时长
				map.set('fileSize', this.recorder.fileSize);//录音总大小

				//录音结束，获取取录音数据
				//map.set('PCMBlob', this.recorder.getPCMBlob());//获取 PCM 数据
				map.set('wavBlob', this.recorder.getWAVBlob());//获取 WAV 数据
				//map.set('mp3Blob', this.convertToMp3(this.recorder.getWAV()));
				//map.set('channel', this.recorder.getChannelData());//获取左声道和右声道音频数据
				return map;
			},
			// 拆分数组
			splitArr(arr, rst, idx) {
				if (!arr || arr.length === 0) {
					return;
				}
				rst.push(arr.splice(0, idx ? idx : 32))
				this.splitArr(arr, rst)
			},
			// 取数组平均数
			arrAverageNum2(arr) {
				let sum = eval(arr.join("+"));
				return ~~(sum / arr.length * 100) / 100;
			},
			// 关闭组件
			close() {
				this.$emit('closeAudio')
			},
			// 销毁实例
			beforeDestroy() {
				this.destroyRecorder();
			}
		}
	}
